'use strict';

module.exports = require('./dom-scroll-into-view');


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-scroll-into-view/lib/index.js
// module id = 74
// module chunks = 0 1